import React from 'react';
import * as s from './styles';

const Button = ({ children, onClick }) => {
  return (
    <s.Button target='_blank' onClick={onClick}>
      {children}
    </s.Button>
  );
};

export default Button;
